import React, { FC, ChangeEvent, useState, useEffect } from "react";
import classnames from "classnames";
import { set } from "lodash";

interface UnknowableNumberProps {
  model: any;
  inputKey: string;
  inputStyle?: React.CSSProperties;
  inputClassName?: string;
  placeholder?: string;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  onCheck: (event: React.FormEvent) => void;
  invalid?: string[];
  type?: string;
}

const UnknowableNumber: FC<UnknowableNumberProps> = ({
  model,
  inputKey,
  inputStyle,
  inputClassName,
  placeholder,
  onChange,
  onCheck,
}) => {
  const qualityAlert = model;
  const [numberBox, setNumberBox] = useState<JSX.Element | null>(null);
  const [isBoxChecked, setIsBoxChecked] = useState(false);
  const [inputValue, setInputValue] = useState<string>("");

  useEffect(() => {
    if (qualityAlert.prrNumber !== "Unknown") {
      setNumberBox(
        <input
          style={inputStyle}
          className={
            "rounded-md border border-gray-300 bg-white p-2 text-black"
          }
          type="text"
          placeholder={placeholder}
          onChange={onTextChange}
        />,
      );
    } else {
      setNumberBox(null);
    }
  }, [qualityAlert.prrNumber, onCheck]);

  const onTextChange = (event: ChangeEvent<HTMLInputElement>) => {
    setInputValue(event.target.value);

    onChange(event);
  };

  const onCheckboxChange = (event: ChangeEvent<HTMLInputElement>) => {
    setIsBoxChecked(!isBoxChecked);

    onCheck(event);
  };

  return (
    <div className="flex items-center">
      {numberBox}
      <div className="ms-1 inline-flex items-center">
        <label className="itemsnap-center relative flex cursor-pointer text-black">
          <input
            type="checkbox"
            className="peer h-5 w-5 cursor-pointer appearance-none rounded border border-black shadow transition-all checked:border-blue-600 checked:bg-blue-600 hover:shadow-md"
            id="check1"
            checked={qualityAlert.prrNumber === "Unknown"}
            onChange={(event: ChangeEvent<HTMLInputElement>) =>
              onCheckboxChange(event)
            }
          />
          <span className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 transform text-white opacity-0 peer-checked:opacity-100">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-3.5 w-3.5"
              viewBox="0 0 20 20"
              fill="currentColor"
              stroke="currentColor"
              strokeWidth="1"
            >
              <path
                fillRule="evenodd"
                d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                clipRule="evenodd"
              ></path>
            </svg>
          </span>
        </label>
        <span className="ms-2 text-[15px] text-black">Unknown</span>
      </div>
    </div>
  );
};

export default UnknowableNumber;
